import arrowCaret from "../../../images/arrow_caret.svg";
import { ReactNode, useState } from "react";
import { UserPreferenceTypes, useUpdateUserPreference } from "../../../graphql";

interface InfoBoxProps {
    initiallyCollapsed: boolean;
    heading: ReactNode;
    content?: ReactNode;
}

export function OrangeInfoBox({ initiallyCollapsed, heading, content }: InfoBoxProps) {
    const [isCollapsed, setCollapsed] = useState(initiallyCollapsed);

    const { updateValue } = useUpdateUserPreference(
        UserPreferenceTypes.VERSION_MANAGEMENT_INFO_BOX_COLLAPSED
    );

    const handleCollapse = () => {
        setCollapsed((prev) => {
            void updateValue(!prev);
            return !prev;
        });
    };

    return (
        <div className="ui orange message" style={{ position: "relative" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <span>{heading}</span>
                {content && (
                    <>
                        <span>{isCollapsed && " ..."}</span>
                        <img
                            src={arrowCaret}
                            alt={isCollapsed ? "Expand" : "Collapse"}
                            onClick={handleCollapse}
                            style={{
                                transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.1s ease",
                                width: "16px",
                                height: "16px",
                                cursor: "pointer",
                            }}
                            title={isCollapsed ? "Expand" : "Collapse"}
                            aria-label={isCollapsed ? "Expand" : "Collapse"}
                        />
                    </>
                )}
            </div>

            {content && !isCollapsed && <div style={{ marginTop: "8px" }}>{content}</div>}
        </div>
    );
}
